import {round} from 'helpers/financial'

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const parseIntWithNull = value => {
  const parsed = parseInt(value)
  return isNaN(parsed) ? null : parsed
}

export const convertBytesToMB = (bytes, dps = 0) =>
  round(bytes / 1024 / 1024, dps)

export const convertMBToBytes = (megabytes) =>
    megabytes * 1024 * 1024

/**
 * Returns the parsed integer when `value` is a number-as-string,
 * otherwise returns the value unchanged (e.g. GUIDs pass through).
 */
export const parseIfNumeric = (value) => {
  if (typeof value !== 'string') return value
  if (GUID_REGEX.test(value)) return value
  // Strict: the entire string must be an integer, nothing else.
  return /^-?\d+$/.test(value) ? parseInt(value, 10) : value
}